export function getDatePublishedPeriod(period = 7) {
  const date = new Date();
  date.setDate(date.getDate() - period);

  return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
}
